<template>
    <div class="push-notice-subscribe-container">
        <span class="title-description">在每次推送前，提前一天钉钉通知到以下人员。</span>
        <el-form :model="pushNoticeSubscribeForm" ref="form">
            <el-form-item>
                <select-users  v-model="pushNoticeSubscribeForm.users" :disabled="isDetail"></select-users>
            </el-form-item>
            <el-button class="next-button" type="primary" size="small" @click="handlerNext" v-if="!isDetail">完成</el-button>
            <el-button class="next-button" size="small" @click="cancel" v-else>取消</el-button>
        </el-form>
    </div>
</template>
<script>
import { mapState,mapActions } from "vuex";
import SelectUsers from './SelectUsers.vue';
export default {
    name: 'push-notice-subscribe',
    components: {
        SelectUsers
    },
    data() {
        return {
            pushNoticeSubscribeForm: {
                users: []
            },
        }
    },
    props: ['isDetail', 'isCopy'],
    computed: {
        ...mapState('pushPushPlanOperate', ['users','data']),
        ...mapState(['$route', '$activeGameCode']),
        userOptions() {
            return this.users.map(item => {
                return {
                    label: item.fullname,
                    value: item.userId,
                    filter_text: `'【'${item.fullname}${item.firstnamePinYin}${item.fullnameFirstLetter}${item.username}'】'`
                }
            })
        }
    },
    watch: {
        data: {
            handler() {
                this.pushNoticeSubscribeForm.users = this.data.notice_config? this.data.notice_config : this.pushNoticeSubscribeForm.users;
            },
            deep: true 
        }
    },
    methods: {
        ...mapActions('pushPushPlanOperate', ['getAllUsers']),
        handlerNext() {
            this.$emit('submit', {notice_config :this.pushNoticeSubscribeForm.users}, 5)
        },
        cancel() {
            window.location.href = `/push/pushplan.html?game_code=${this.$activeGameCode}`;
        }
    },
    created() {
        this.getAllUsers();
    }
}
</script>



// WEBPACK FOOTER //
// website/subComponents/push/PushNoticeSubscribe.vue